import {WlTextInput} from "./textInput.component";
import { defineWebComponent } from "../webcomponents-utils";

export * from './textInput.component';
export default WlTextInput;

defineWebComponent('wl-text-input', WlTextInput);
